import gql from 'graphql-tag'

const createCoupon = gql`
  mutation createCoupon($coupon: CreateCoupon!) {
    createCoupon(coupon: $coupon) {
      id
      codice
      stato
      importo
      clienteId
      cliente {
        id
        nome
      }
      dataCreazione
      dataLimiteAssegnazione
      dataLimiteAttivazione
      dataLimiteUtilizzo
      tipologia
    }
  }
`

export default createCoupon



// WEBPACK FOOTER //
// ./src/graphql/mutations/createCoupon.js